// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"EditClientModal_modalContainer__2WOKF","title":"EditClientModal_title__1SfmS","formContainer":"EditClientModal_formContainer__3vXdm"};